/* eslint-disable import/no-default-export */
export default {
  'AgenticDuoChat.chatCancelLabel': 'Cancel',
  'AgenticDuoChat.chatDefaultPredefinedPromptsChangePassword':
    'How do I change my password in GitLab?',
  'AgenticDuoChat.chatDefaultPredefinedPromptsCloneRepository': 'How do I clone a repository?',
  'AgenticDuoChat.chatDefaultPredefinedPromptsCreateTemplate': 'How do I create a template?',
  'AgenticDuoChat.chatDefaultPredefinedPromptsForkProject': 'How do I fork a project?',
  'AgenticDuoChat.chatDefaultTitle': 'GitLab Duo Agentic Chat',
  'AgenticDuoChat.chatDisclamer':
    'Chat can autonomously change code. Responses and changes can be inaccurate. Review carefully.',
  'AgenticDuoChat.chatEmptyStateTitle':
    '👋 I am GitLab Duo Agentic Chat, your personal AI-powered assistant. How can I help you today?',
  'AgenticDuoChat.chatHistoryTitle': 'Chat history',
  'AgenticDuoChat.chatPromptPlaceholderDefault': 'GitLab Duo Agentic Chat',
  'AgenticDuoChat.chatPromptPlaceholderWithCommands': 'Type /help to learn more',
  'AgenticDuoChat.chatSubmitLabel': 'Send chat message.',
  'AgenticDuoChat.overLimitCharacterCountMessage': null,
  'AgenticDuoChat.remainingCharacterCountMessage': null,
  'AgenticToolApprovalFlow.defaultDescription':
    'GitLab Duo Agentic Chat wants to execute a tool. Do you want to proceed?',
  'AgenticToolApprovalModal.approveAllText': 'Always approve this tool',
  'AgenticToolApprovalModal.approveOnceText': 'Approve Once',
  'AgenticToolApprovalModal.approveText': 'Approve',
  'AgenticToolApprovalModal.defaultDescription':
    'GitLab Duo Agentic Chat wants to execute a tool. Do you want to proceed?',
  'AgenticToolApprovalModal.denyText': 'Deny',
  'AgenticToolApprovalModal.title': 'Tool Approval Required',
  'AgenticToolApprovalModal.toolLabel': 'Tool:',
  'AgenticToolApprovalModal.toolUnknown': 'Unknown',
  'AgenticToolRejectionModal.backText': 'Back',
  'AgenticToolRejectionModal.description':
    'You are about to reject the tool execution. Would you like to provide a reason?',
  'AgenticToolRejectionModal.label': 'Rejection reason',
  'AgenticToolRejectionModal.placeholder': "Explain why you're rejecting this tool execution...",
  'AgenticToolRejectionModal.submitText': 'Submit Rejection',
  'AgenticToolRejectionModal.title': 'Provide Rejection Reason',
  'BaseToolParams.ExpandDescriptionTitle': 'Read description',
  'BaseToolParams.ExpandJsonViewTitle': 'See request parameters as JSON',
  'BaseToolParams.confidentialLabel': 'Confidential',
  'BaseToolParams.dismissalReasonLabel': 'Dismissal reason',
  'BaseToolParams.dueDateLabel': 'Due date',
  'BaseToolParams.epicLabel': 'Epic',
  'BaseToolParams.groupLabel': 'Group',
  'BaseToolParams.healthStatusLabel': 'Health status',
  'BaseToolParams.issueLabel': 'Issue',
  'BaseToolParams.labelsLabel': 'Labels',
  'BaseToolParams.mergeRequestLabel': 'Merge request',
  'BaseToolParams.projectLabel': 'Project',
  'BaseToolParams.sourceBranchLabel': 'Source branch',
  'BaseToolParams.startDateLabel': 'Start date',
  'BaseToolParams.stateLabel': 'State',
  'BaseToolParams.targetBranchLabel': 'Target branch',
  'BaseToolParams.typeLabel': 'Type',
  'BaseToolParams.vulnerabilityLabel': 'Vulnerability',
  'BaseToolParams.workItemLabel': 'Work item',
  'CreateCommitToolParams.actionWithNoContent': 'This action does not have any content.',
  'CreateCommitToolParams.actionsCountMessage': null,
  'CreateCommitToolParams.chmodFileActionLabel': 'Change permissions for file %{filePath}',
  'CreateCommitToolParams.commitSummaryAutoBranchMessage':
    'Create a commit in a new auto-created branch.',
  'CreateCommitToolParams.commitSummaryMessage': 'Create a commit in the branch %{branch}.',
  'CreateCommitToolParams.createFileActionLabel': 'Create file %{filePath}',
  'CreateCommitToolParams.deleteFileActionLabel': 'Delete file %{filePath}',
  'CreateCommitToolParams.expandFileChanges': 'Expand file changes',
  'CreateCommitToolParams.moveFileActionLabel': 'Move file %{filePath}',
  'CreateCommitToolParams.noActionsMessage': 'The commit does not contain changes.',
  'CreateCommitToolParams.readCommitMessage': 'Read commit message',
  'CreateCommitToolParams.unknownFileActionLabel': 'Modify file %{filePath}',
  'CreateCommitToolParams.updateFileActionLabel': 'Update file %{filePath}',
  'DuoChat.chatBackLabel': 'Back to history',
  'DuoChat.chatBackToChatToolTip': 'Back to chat',
  'DuoChat.chatCancelLabel': 'Cancel',
  'DuoChat.chatDefaultPredefinedPromptsChangePassword': 'How do I change my password in GitLab?',
  'DuoChat.chatDefaultPredefinedPromptsCloneRepository': 'How do I clone a repository?',
  'DuoChat.chatDefaultPredefinedPromptsCreateTemplate': 'How do I create a template?',
  'DuoChat.chatDefaultPredefinedPromptsForkProject': 'How do I fork a project?',
  'DuoChat.chatDefaultTitle': 'GitLab Duo Chat',
  'DuoChat.chatDropdownMoreOptions': 'More options',
  'DuoChat.chatEmptyStateTitle':
    '👋 I am GitLab Duo Chat, your personal AI-powered assistant. How can I help you today?',
  'DuoChat.chatHistoryInfo': 'Inactive chats are deleted after 30 days.',
  'DuoChat.chatHistoryToolTip': 'Chat history',
  'DuoChat.chatNewLabel': 'New chat',
  'DuoChat.chatNewToolTip': 'New chat',
  'DuoChat.chatPromptPlaceholderDefault': 'GitLab Duo Chat',
  'DuoChat.chatPromptPlaceholderWithCommands': 'Type /help to learn more',
  'DuoChat.chatSubmitLabel': 'Send chat message.',
  'DuoChat.chatTitle': 'GitLab Duo Chat',
  'DuoChat.closeChatHeaderLabel': 'Close chat',
  'DuoChat.copySessionIdFailedToast': 'Could not copy session ID',
  'DuoChat.copySessionIdSuccessToast': 'Session ID copied to clipboard',
  'DuoChat.copySessionIdTooltip': 'Copy session ID: %{id}',
  'DuoChat.emptyHistoryAlt':
    'Clock icon with circular arrow, indicating chat history or time-based functionality',
  'DuoChat.emptyHistoryCopy': 'Your previous chats will appear here.',
  'DuoChat.emptyHistoryTitle': 'See your chat history',
  'DuoChat.openChatLabel': 'Open chat: %{title}',
  'DuoChat.threadDeleteLabel': 'Delete this chat',
  'DuoChat.untitledChatTitle': 'Untitled Chat',
  'DuoChat.verifiedAgent': 'Created and maintained by GitLab',
  'DuoChatContextItemDetailsModal.contentErrorMessage': 'Item content could not be displayed.',
  'DuoChatContextItemDetailsModal.title': 'Preview',
  'DuoChatContextItemMenu.emptyStateMessage': 'No results found',
  'DuoChatContextItemMenu.loadingMessage': 'Loading...',
  'DuoChatContextItemMenu.searchInputPlaceholder': 'Search %{categoryLabel}...',
  'DuoChatContextItemMenu.selectedContextItemsTitle': 'Included references',
  'DuoChatContextItemPopover.DisabledReason': 'This item is disabled',
  'DuoChatConversation.newChat': 'New chat',
  'DuoChatLoader.gitlabDuo': 'GitLab Duo',
  'DuoChatLoader.loaderLoadingMessage': '%{tool} is %{transition} an answer',
  'DuoChatLoader.loaderLoadingTransitionsFinding': 'finding',
  'DuoChatLoader.loaderLoadingTransitionsGenerating': 'generating',
  'DuoChatLoader.loaderLoadingTransitionsProducing': 'producing',
  'DuoChatLoader.loaderLoadingTransitionsWorkingOn': 'working on',
  'DuoChatMessage.SelectedContextItemsTitleAssistantMessage': null,
  'DuoChatMessage.SelectedContextItemsTitleUserMessage': null,
  'DuoChatMessage.branchLabel': 'Branch',
  'DuoChatMessage.chatMessageCopied': 'Copied',
  'DuoChatMessage.chatMessageCopyToClipboard': 'Copy to clipboard',
  'DuoChatMessage.collapseDetails': 'Collapse details',
  'DuoChatMessage.expandDetails': 'Expand details',
  'DuoChatMessage.fromDuo': 'Duo:',
  'DuoChatMessage.fromMe': 'Me:',
  'DuoChatMessage.modalAlertText':
    'GitLab team members cannot view your conversation. Please be as descriptive as possible.',
  'DuoChatMessage.modalBetterResponse': 'How the response might better meet your needs.',
  'DuoChatMessage.modalDidWhat': 'What were you doing?',
  'DuoChatMessage.modalImproveWhat': 'How could the response be improved?',
  'DuoChatMessage.modalInteraction': 'The situation in which you interacted with GitLab Duo Chat.',
  'DuoChatMessage.modalMessageError': 'Error sending the message',
  'DuoChatMessage.modalTitle': 'Give feedback on GitLab Duo Chat',
  'DuoChatMessage.projectLabel': 'Project',
  'DuoChatMessage.startBranchLabel': 'Start branch',
  'DuoChatMessageSources.messageSources': null,
  'DuoRecentCollapsable.viewAllText': 'View All',
  'GlDuoChat.chatDisclamer': 'Responses may be inaccurate. Verify before use.',
  'GlDuoChat.chatHistoryTitle': 'Chat history',
  'IssuableToolParams.NOTE_ACCORDION_TITLE': "Read note's content",
  'IssuableToolParams.TITLE_MESSAGE': 'Set the title "<em>%{title}</em>".',
  'MessageToolApproval.approveAllText': 'Always approve this tool',
  'MessageToolApproval.approveSessionText': 'Approve for session',
  'MessageToolApproval.approveText': 'Approve',
  'MessageToolApproval.approvingText': 'Approving...',
  'MessageToolApproval.cancelText': 'Cancel',
  'MessageToolApproval.collapseButtonCollapsed': 'Display tool details',
  'MessageToolApproval.collapseButtonExpanded': 'Hide tool details',
  'MessageToolApproval.denialReasonLabel': 'Rejection reason',
  'MessageToolApproval.denialReasonPlaceholder':
    "Tell Duo why you're rejecting this tool execution...",
  'MessageToolApproval.denyText': 'Deny',
  'MessageToolApproval.denyingText': 'Denying...',
  'MessageToolApproval.multiToolTitle': 'Duo wants to execute %{count} tools.',
  'MessageToolApproval.noParametersText': 'No parameters will be sent with this request.',
  'MessageToolApproval.parametersText': 'Request parameters',
  'MessageToolApproval.toolApprovalDescription':
    'GitLab Duo Agentic Chat wants to execute a tool. Do you want to proceed?',
  'MessageToolApproval.toolLabel': 'Tool:',
  'MessageToolApproval.toolStatusApproved': 'Approved',
  'MessageToolApproval.toolStatusPending': 'Pending',
  'MessageToolApproval.toolUnknown': 'Unknown',
  No: 'No',
  'PreBlock.COPY_TO_CLIPBOARD_TEXT': 'Copy to clipboard',
  'RunCommandToolParams.ACCORDION_TITLE': 'Expand command output',
  'WebAgenticDuoChat.agenticChatEmptyStateGreeting': 'Hello, I’m %{agentName}!',
  'WebAgenticDuoChat.chatCancelLabel': 'Cancel',
  'WebAgenticDuoChat.chatDefaultPredefinedPromptsChangePassword':
    'How do I change my password in GitLab?',
  'WebAgenticDuoChat.chatDefaultPredefinedPromptsCloneRepository': 'How do I clone a repository?',
  'WebAgenticDuoChat.chatDefaultPredefinedPromptsCreateTemplate': 'How do I create a template?',
  'WebAgenticDuoChat.chatDefaultPredefinedPromptsForkProject': 'How do I fork a project?',
  'WebAgenticDuoChat.chatDefaultTitle': 'GitLab Duo Agentic Chat',
  'WebAgenticDuoChat.chatDisclamer': 'Responses may be inaccurate. Verify before use.',
  'WebAgenticDuoChat.chatEmptyStateDescription': 'How can I help you today?',
  'WebAgenticDuoChat.chatEmptyStateTitle':
    'I am GitLab Duo Agentic Chat, your personal AI-powered assistant.',
  'WebAgenticDuoChat.chatHistoryTitle': 'Chat history',
  'WebAgenticDuoChat.chatModelPlaceholder': 'GitLab Duo Agentic Chat',
  'WebAgenticDuoChat.chatPromptPlaceholderDefault': "Let's work through this together...",
  'WebAgenticDuoChat.chatPromptPlaceholderWithCommands': 'Type /help to learn more',
  'WebAgenticDuoChat.chatSubmitLabel': 'Send chat message.',
  'WebAgenticDuoChat.overLimitCharacterCountMessage': null,
  'WebAgenticDuoChat.remainingCharacterCountMessage': null,
  'WebDuoChat.chatBackToChatToolTip': 'Back to chat',
  'WebDuoChat.chatCancelLabel': 'Cancel',
  'WebDuoChat.chatDefaultPredefinedPromptsChangePassword': 'How do I change my password in GitLab?',
  'WebDuoChat.chatDefaultPredefinedPromptsCloneRepository': 'How do I clone a repository?',
  'WebDuoChat.chatDefaultPredefinedPromptsCreateTemplate': 'How do I create a template?',
  'WebDuoChat.chatDefaultPredefinedPromptsForkProject': 'How do I fork a project?',
  'WebDuoChat.chatDefaultTitle': 'GitLab Duo Chat',
  'WebDuoChat.chatDisclamer': 'Responses may be inaccurate. Verify before use.',
  'WebDuoChat.chatDropdownMoreOptions': 'More options',
  'WebDuoChat.chatEmptyStateDescription': 'How can I help you today?',
  'WebDuoChat.chatEmptyStateTitle': 'I am GitLab Duo Chat, your personal AI-powered assistant.',
  'WebDuoChat.chatHistoryTitle': 'Chat history',
  'WebDuoChat.chatModelPlaceholder': 'GitLab Duo Chat',
  'WebDuoChat.chatPromptPlaceholderDefault': "Let's work through this together...",
  'WebDuoChat.chatPromptPlaceholderWithCommands': 'Type /help to learn more',
  'WebDuoChat.chatSubmitLabel': 'Send chat message.',
  'WebDuoChat.chatTitle': 'GitLab Duo Chat',
  'WebDuoChat.closeChatHeaderLabel': 'Close chat',
  'WebDuoChat.copySessionIdFailedToast': 'Could not copy session ID',
  'WebDuoChat.copySessionIdSuccessToast': 'Session ID copied to clipboard',
  'WebDuoChat.copySessionIdTooltip': 'Copy Chat Session ID (%{id})',
  'WebDuoChat.overLimitCharacterCountMessage': null,
  'WebDuoChat.remainingCharacterCountMessage': null,
  Yes: 'Yes',
};
